import type { FaireProductEntity } from "../../entity_types/product";

export const p_shb2xj8w7t: FaireProductEntity = {
  token: "p_shb2xj8w7t",
  type: "product",
  name: "Gardener Set of Two Stitched Notebooks Journals",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d6398f2fdc4c31322a9f501886d8d9661e96e94a94276b5566bbf69f753456df.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a90286934050b3d6df03163dff910a8838bb60c8d0b86402d828ecef1c48d53.jpeg",
    "https://cdn.faire.com/fastly/dbcee8a8a2cb4d03c118808df06fb5da9776de37cfec86b71efdf3f232330bc4.jpeg",
    "https://cdn.faire.com/fastly/2f7d8466de307f25eba9cb359ffc0e1d4008b2baa4d6dc205f5eeb23ac8affca.jpeg",
    "https://cdn.faire.com/fastly/88a0705b025cf36d4959782fa0a3ad1650a76889158610e2989e30769099c4a8.jpeg",
  ],
  priceDollars: 8,
  description:
    "Who among us does not have an entire ocean of thoughts floating around in our heads? Nobody! A notebook is the perfect way to calm the cranial seas... simply write things down. And this set of 2 gives you so many options—make one messy, one clean. One to remember, one to forget. Likes, dislikes. Business in the front, party in the back. Have fun seeing what your thought waves will come up with.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:55.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
